import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdateCountryCodeBlockModal, BackButton, BadgeComponent, Breadcrumbs, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { VerticalDotsSvg } from "../../assets/svgs";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { getCountryCodeBlockManagementInboxData , postAddedUpdateCountryCodeReview } from "../../redux/slices/country-code-management-inbox-slice";
import { getAllAvailableCountryCodeList } from "../../redux/slices/global-country-code-block-slice";
import { Menus } from "../../constants/menus-constant";
import { useLocation } from "react-router";
import ReactTable from "react-table";

const CountryBlockManagementInbox = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { loading, inboxData, pagination } = useSelector((state) => state.CountryCodeBlockManagementInboxSlice);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];
    const isChecker = location.pathname.includes('checker'); // Check if the current path includes 'checker'

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: true,
    };

    const [states, setStates] = useState(initialStates);
    const [form, setForm] = useState();

    const defaultParams = { pagination: states.pagination };

    const getInboxData = async (updatedParams) => {
        if (user && updatedParams) {
            try {
                await Promise.all([
                    dispatch(getCountryCodeBlockManagementInboxData({ user, ...updatedParams })),
                    dispatch(getAllAvailableCountryCodeList({ user, search: { institutionCode: null } })),
                ]);
            } catch (error) {
                console.error("One or more API calls failed", error);
            }
        }
    };

    // const handleReload = () => {
    //     getInboxData(defaultParams);
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getInboxData(params);
    };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    const handleModalOpen = () => {
        const { reason, taskDetailRes } = states.selected;
        setForm({ ...taskDetailRes, institutionCode: taskDetailRes?.institutionCode?.id, reason });

        setStates((old) => ({ ...old, isModalOpen: true }));
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null }));
    };

    const handleFormSubmit = (payloads) => {
        const { operation, processId } = states.selected;
        const { blockedCountryRequest, ...payload } = payloads;

        const updatedPayload = {
            ...payload,
            operation,
            processId,
            blockedCountryRequest: blockedCountryRequest,
        };

        dispatch(postAddedUpdateCountryCodeReview({ user, body: updatedPayload })).then((action) => {
            if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                handleModalClose();
                getInboxData(defaultParams);
            }
        });
    };

    const actions = [
        { label: isChecker ? 'Review' : 'Edit', action: () => handleModalOpen() },
    ];

    useEffect(() => {
        getInboxData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (inboxData && Array.isArray(inboxData)) {
            setStates((old) => ({ ...old, data: inboxData, pagination: pagination }));
        }
    }, [inboxData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // TABLE COLUMNS SETUP AS PER DATA
    // const columns = [
    //     { field: 'processId', headerName: 'Process ID', width: 150 },
    //     {
    //         field: 'merchants',
    //         headerName: 'MCC Codes',
    //         sortable: false,
    //         width: 150,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             const merchants = row?.taskDetailRes?.merchants;
    //             if (merchants && merchants.length > 0) {
    //                 const firstThree = merchants.slice(0, 3).map(m => m.code).join(', ');
    //                 const extra = merchants.length > 3 ? `, +${merchants.length - 3}` : '';
    //                 return firstThree + extra;
    //             }
    //             return '';
    //         },
    //     },
    //     {
    //         field: 'operation',
    //         headerName: 'Operation',
    //         width: 150,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.operation &&
    //                         <BadgeComponent label={row?.operation} outline type='error' width={125} />
    //                     }
    //                 </>
    //             );
    //         },
    //         sortBy: (row) => row?.operation,
    //     },
    //     ...((states?.data?.some((e) => e?.operation?.toLowerCase()?.includes('participant'))) ? [{
    //         field: 'institutionCode',
    //         headerName: 'Participants',
    //         width: 160,
    //         valueGetter: (row) => row?.taskDetailRes?.institutionCode?.descr,
    //         sortBy: (row) => row?.taskDetailRes?.institutionCode?.descr,
    //     }] : []),
    //     { field: 'createdBy', headerName: 'Created / Modified By', width: 160 },
    //     {
    //         field: 'isaccepted',
    //         headerName: 'Status',
    //         width: 120,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         ([true, false].includes(row?.isaccepted) && row?.reason) ? (
    //                             <BadgeComponent label={row?.isaccepted ? 'Accepted' : 'Rejected'} type={row?.isaccepted ? 'success' : 'error'} />
    //                         ) : (
    //                             <BadgeComponent label='Pending' type='default' />
    //                         )
    //                     }
    //                 </>
    //             )
    //         },
    //         // sortBy: (row) => row.userStatus.label,
    //     },
    //     { field: 'reason', headerName: 'Comments', width: 140 },
    //     { field: 'reqInitDateTime', headerName: 'Request Date', width: 170, align: 'center' },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];

    const columns = useMemo(() => [
        {
            accessor: 'reqInitDateTime', Header: 'Request Date', minWidth: 170,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'processId', Header: 'Process ID', minWidth: 150,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'numericCode',
            Header: 'Numeric Codes',
            minWidth: 150,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                const numericCodes = row?.original?.taskDetailRes?.countries;
                if (numericCodes && numericCodes.length > 0) {
                    const firstThree = numericCodes
                        .slice(0, 3)
                        .map(m => m.numericCode)
                        .join(', ');
                    const extra = numericCodes.length > 3 ? `, +${numericCodes.length - 3}` : '';
                    return firstThree + extra;
                }
                return '';
            },
            sortable: false,
            filterable: false,
        },

        {
            accessor: 'operation',
            Header: 'Operation',
            minWidth: 200,
            style: {
                textAlign: 'center',
            },
            sortable: false,
            filterable: false,
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.operation &&
                            <BadgeComponent label={row?.original?.operation} outline type='error' width={145} />
                        }
                    </>
                )
            },
        },
        ...((states?.data?.some((e) => e?.operation?.toLowerCase()?.includes('participant'))) ? [{
            accessor: 'institutionCode',
            Header: 'Participants',
            minWidth: 160,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row?.original?.taskDetailRes?.institutionCode?.descr,
            sortable: false,
            filterable: false
        }] : []),
        {
            accessor: 'createdBy', Header: 'Created / Modified By', minWidth: 160,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'isaccepted',
            Header: 'Status',
            minWidth: 170,
            style: {
                textAlign: 'center'
            },
            sortable: false,
            filterable: false,
            Cell: (row) => {
                return (
                    <>
                        {
                            ([true, false].includes(row?.original?.isaccepted) && row?.original?.reason) ? (
                                <BadgeComponent label={row?.original?.isaccepted ? 'Accepted' : 'Rejected'} type={row?.original?.isaccepted ? 'success' : 'error'} />
                            ) : (
                                <BadgeComponent label='Pending' type='default' />
                            )
                        }
                    </>
                )
            },
        },
        {
            accessor: 'reason', Header: 'Comments', minWidth: 120,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Inbox</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel },
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>
            </AuthPageHead>

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/*
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            */}

            {/* PAGE CONTENT */}
            {
               <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={false}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen &&
                <AddUpdateCountryCodeBlockModal
                    data={form}
                    label={states?.selected?.operation}
                    update={states.isUpdate}
                    close={handleModalClose}
                    handleFormSubmit={handleFormSubmit}
                    fromMakerChecker
                    fromParticipantlevel={states?.selected?.operation?.toLowerCase()?.includes('participant')}
                    fromRemoveCountry={states?.selected?.operation?.toLowerCase()?.includes('remove')}
                    slide
                />
            }
        </AuthPageContainer>
    );
};

export default CountryBlockManagementInbox;